import { GenerateLicenseModel, GenerateLicenseModelApi } from '../../../../domainModels/licences/GenerateLicense';
import { LicenseType, mapLicenseTypeToApiModel } from '../../../../domainModels/licences/LicenseType';
import { PaymentStatus, mapPaymentStatusToApiModel } from '../../../../domainModels/licences/PaymentStatus';
import { dateToApiDateStringFormat } from '../../../../helpers/moment';
export const generateLicenseModelToApi = (model: GenerateLicenseModel): GenerateLicenseModelApi => ({
    ...model,
    paymentDeadline: dateToApiDateStringFormat(model.paymentDeadline),
    validFrom: dateToApiDateStringFormat(model.validFrom),
    validTo: dateToApiDateStringFormat(model.validTo),
    paymentStatus: mapPaymentStatusToApiModel(model.paymentStatus) || PaymentStatus.Awaiting,
    licenceType: mapLicenseTypeToApiModel(model.type) || LicenseType.Commercial,
});
